module.exports = __webpack_public_path__ + "static/media/cooler.ded2a942.png";